import {vnode} from 'snabbdom/build/package/vnode';
import {eventListenersModule} from 'snabbdom/build/package/modules/eventlisteners';
import {styleModule} from 'snabbdom/build/package/modules/style';
import {classModule} from 'snabbdom/build/package/modules/class';
import {datasetModule} from 'snabbdom/build/package/modules/dataset';
import {props, ref, attributes} from '../modules';
import patch from './patch';

const TAG_PLACEHOLDER = 'sn-ssr-placeholder';

const emptyNode = vnode('', {}, [], undefined, undefined);
const modules = [
	props,
	attributes,
	classModule,
	styleModule,
	eventListenersModule,
	datasetModule,
	ref
];

export function hydrate(oldVnode, vnode) {
	// placeholder is temporary element,
	// eventually updated with intended content when available
	if (oldVnode?.sel === TAG_PLACEHOLDER) {
		patch(oldVnode, vnode);
		return {error: null};
	}

	if (vnode.sel && oldVnode.sel !== vnode.sel) {
		return {error: {server: oldVnode.sel, client: vnode.sel}};
	}
	if (vnode.text && oldVnode.text !== vnode.text) {
		return {error: {server: `"${oldVnode.text}"`, client: `"${vnode.text}"`}};
	}
	if (vnode.children) {
		if (oldVnode.children.length !== vnode.children.length) {
			return {
				error: {
					server: `${oldVnode.children.length} children`,
					client: `${vnode.children.length} children`
				}
			};
		}
		for (let i = 0; i < oldVnode.children.length; i++) {
			const {error} = hydrate(oldVnode.children[i], vnode.children[i]);
			if (error) {
				return {error};
			}
		}
	}

	vnode.elm = oldVnode.elm;
	if (vnode.data?.hook?.init) {
		vnode.data.hook.init(vnode);
	}
	if (vnode.data?.hook?.create) {
		vnode.data.hook.create(emptyNode, vnode);
	}
	if (vnode.data?.hook?.insert) {
		vnode.data.hook.insert(vnode);
	}
	if (vnode.data) {
		modules.forEach(module => module.create(oldVnode, vnode));
	}

	return {error: null};
}
